import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

export default function SuperAdminOverview() {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/admin/stats").then(r => setStats(r.data)); }, []);
  if (!stats) return <div className="text-slate-500">Loading…</div>;
  return (
    <div className="space-y-5 fade-in">
      <p className="text-slate-600">Platform-wide health and revenue indicators.</p>
      <div className="grid md:grid-cols-4 gap-4">
        <Kpi label="Tenants" value={stats.tenants} tone="brand"/>
        <Kpi label="Users" value={stats.users} tone="cyan"/>
        <Kpi label="Surveys" value={stats.surveys} tone="emerald"/>
        <Kpi label="Responses" value={stats.responses} tone="rose"/>
      </div>

      <Card className="p-6 border-slate-100">
        <p className="text-xs uppercase tracking-wider text-slate-500 font-semibold">Plan distribution</p>
        <div className="mt-3 flex flex-wrap gap-2">
          {Object.entries(stats.by_plan || {}).map(([plan, count]) => (
            <Badge key={plan} className="bg-[#FFF0DF] text-[#1F3A6B] border border-[#FFE1BE] text-sm uppercase">{plan}: {count}</Badge>
          ))}
          {Object.keys(stats.by_plan || {}).length === 0 && <p className="text-sm text-slate-500">No tenants yet.</p>}
        </div>
      </Card>
    </div>
  );
}

function Kpi({ label, value, tone }) {
  const map = { brand: "text-[#1F3A6B]", cyan: "text-[#F58220]", emerald: "text-emerald-600", rose: "text-rose-600" };
  return (
    <Card className="p-5 border-slate-100">
      <p className="text-xs uppercase tracking-wider text-slate-500 font-semibold">{label}</p>
      <p className={`mt-2 text-4xl font-extrabold tabular-nums ${map[tone]}`}>{value}</p>
    </Card>
  );
}
